<template>
  <div>
    <div v-if="busData" class="pt-2" :class="{ 'px-3': $vuetify.breakpoint.mdAndUp }">
      <Breadcrumbs
        :class="{ 'px-5 mt-2': $vuetify.breakpoint.smAndDown }"
        data="busData.name"
        :headline="busData.name"
        :link="[
          { text: 'Danh sách xe tuyến', href: '../busList' },
          { text: busData.name, id: busData.id }
        ]"
      />
      <v-card class="d-flex justify-space-between align-center my-4 pa-5 border" outlined>
        <v-row no-gutters>
          <v-col cols="12" md="2">
            <span>
              Tên tuyến
            </span>
            <h4>{{ busData.name || '' }}</h4>
          </v-col>
          <v-col cols="12" md="2">
            <div>GV phụ trách</div>
            <router-link
              v-if="busData.driver"
              style="text-decoration: none"
              :to="'/teacher/' + get(busData, 'driver._id')"
            >
              <div>{{ get(busData, 'driver.name') }}</div>
            </router-link>
          </v-col>
          <v-col cols="12" md="2">
            <div>SĐT GV phụ trách</div>
            <div class="font-weight-bold">
              {{ busData.phone || '' }}
            </div>
          </v-col>
          <v-col cols="12" md="2">
            <div>Số học sinh tối đa</div>
            <div class="font-weight-bold">{{ busData.data && busData.data.maxStudent }}</div>
          </v-col>
          <v-col cols="12" md="2">
            <div>Tình trạng</div>
            <v-chip small class="white--text" v-if="busData.status" :color="busData.status | busStatusColor" label>
              {{ busData.status | busStatus }}
            </v-chip>
          </v-col>
          <v-col cols="12" md="2" class="detail d-flex justify-end align-center">
            <v-btn class="search-button ml-6" @click="detailState = !detailState" outlined>
              Hồ sơ chi tiết
            </v-btn>
          </v-col>
          <v-col class="mt-4" cols="12" md="12">
            <div>Ghi chú</div>
            <span class="font-weight-bold">{{ busData.notes || '' }}</span>
          </v-col>
        </v-row>
      </v-card>
      <BusScheduleTabs class="mt-8" />
      <div class="text-center">
        <v-btn class="ma-4" @click="remove" color="red" outlined>Xóa tuyến xe</v-btn>
      </div>
      <BusDetailDialog @edit="updateDialogState = !updateDialogState" :busData="busData" :state="detailState" />

      <BusUpdateDialog :state="updateDialogState" :busData="busInfo"></BusUpdateDialog>
    </div>
    <h1 v-else-if="!$loading.active">Bus not found</h1>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { get } from 'lodash'
import BusScheduleTabs from '@/modules/bus/BusScheduleTabs.vue'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import BusUpdateDialog from '@/modules/bus/BusUpdateDialog.vue'
import BusDetailDialog from '@/modules/bus/BusDetailDialog.vue'

export default {
  components: {
    Breadcrumbs,
    BusUpdateDialog,
    BusDetailDialog,
    BusScheduleTabs
  },
  data() {
    return {
      updateDialogState: false,
      tab: null,
      detailState: false,
      dialog: false
    }
  },
  computed: {
    ...mapGetters('busDetail', ['busData']),
    busInfo() {
      return this.busData
    }
  },
  methods: {
    ...mapActions('busDetail', ['initBus']),
    ...mapActions('bus', ['removeBus']),
    get,
    remove() {
      this.$dialog.confirm({
        title: 'Xác nhận xóa tuyến xe',
        text:
          'Tuyến xe này sẽ bị xóa khỏi danh sách xe tuyến. Thao tác này sẽ không thể hoàn tác. Bạn có chắc chắn muốn xóa tuyến xe?',
        okText: 'OK',
        cancelText: 'Hủy',
        type: 'delete',
        done: async () => {
          try {
            await this.removeBus(this.busData.id)
            this.$alert.success('Xóa tuyến xe thành công!')
            this.$router.push(`/busList/`)
          } catch (error) {
            this.$alert.deleteError()
          } finally {
            this.$loading.active = false
          }
        }
      })
    }
  },
  async created() {
    await this.initBus(this.$route.params.id)
  }
}
</script>
<style scoped>
.theme--light.v-tabs-items {
  background-color: transparent;
}
td {
  padding-top: 4px;
}
td:first-child {
  padding-right: 48px;
}
</style>
